import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkAuth } from "@actions/auth/checkAuth";
import { Spinner } from "@components/library/Spinner";
import { useLanguageDetection } from "./hooks/useLanguageDetection";

export const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  const { isDetecting: isDetectingLanguage } = useLanguageDetection();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await dispatch(checkAuth());
      } catch (e) {
      } finally {
        setIsAuthChecked(true);
      }
    };
    verifyAuth();
  }, [dispatch]);

  if (!isAuthChecked || isDetectingLanguage) {
    return <Spinner />;
  }

  return children;
};
